import dayjs from "dayjs"

export const getAddTaskInitialValues = lead => {
  const { inquiryStatusDetails, tasks, Project, inquiry, isEditable } = lead || {}

  const toDayjs = date => (date ? dayjs(date) : dayjs())

  let preFilledObject = {
    task: null,
    subTask: null,
    subofSubTask: null,
    subLocation: null,
    nextTask: null,
  }

  if (inquiryStatusDetails) {
    const {
      taskStatusGreatGrandParentKey,
      taskStatusGrandParentKey,
      taskStatusParentKey,
      taskStatusKey,
      nextStatusKey,
    } = inquiryStatusDetails

    if (taskStatusParentKey === "sales") {
      preFilledObject = {
        task: null,
        subTask: null,
        subofSubTask: null,
        subLocation: null,
        nextTask: null,
      }
    } else if (!!taskStatusGreatGrandParentKey) {
      preFilledObject = {
        task: taskStatusGreatGrandParentKey,
        subTask: taskStatusGrandParentKey,
        subofSubTask: taskStatusParentKey,
        subLocation: taskStatusKey,
        nextTask: nextStatusKey,
      }
    } else if (!!taskStatusGrandParentKey) {
      preFilledObject = {
        task: taskStatusGrandParentKey,
        subTask: taskStatusParentKey,
        subofSubTask: taskStatusKey,
        nextTask: nextStatusKey,
      }
    } else {
      preFilledObject = {
        task: taskStatusParentKey,
        subTask: taskStatusKey,
        nextTask: nextStatusKey,
      }
    }
  }

  const lastTask = tasks?.find(item => item.hasOwnProperty("todoDetails"))
  return {
    ...preFilledObject,
    nextTask: !!preFilledObject.nextTask ? preFilledObject.nextTask : null,
    project: Project?.name ?? null,
    verifyMeeting: "",
    showOtpfield: null,
    meetingName: inquiry?.Client?.name ? `Client Meeting - ${inquiry?.Client?.name} - ${dayjs().format("MMM DD, YYYY")}` : null,
    clientEmail: inquiry?.Client?.email,
    leadsClassification: inquiry?.InternalInquiryClassification?.id?.toString() ?? "",
    tsrClassification: inquiry?.TSRClassification?.id?.toString() ?? "",
    completionDate: toDayjs(isEditable ? lastTask?.deadline : null),
    newMeetingDate: toDayjs(isEditable ? lastTask?.deadline : null),
    deadLine: toDayjs(
      isEditable && lastTask?.todoDetails?.nextStatusDeadline ? lastTask?.todoDetails?.nextStatusDeadline : null
    ),
    salesEvent: lastTask?.salesEventId ?? null,
    /** Hydrate range when editing a task that stored meeting window on `Event` (calendar may omit past events from the list). */
    meetingTime:
      isEditable && lastTask?.Event?.startTimeStamp && lastTask?.Event?.endTimeStamp
        ? [toDayjs(lastTask.Event.startTimeStamp), toDayjs(lastTask.Event.endTimeStamp)]
        : undefined,
    attachment: lastTask?.Attachments ?? [],
    dateSlot: toDayjs(lastTask?.todoDetails?.nextStatusDeadline),
    timeSlot: lastTask?.Event
      ? [toDayjs(lastTask?.Event?.startTimeStamp), toDayjs(lastTask?.Event?.endTimeStamp)]
      : undefined,
  }
}
